if(!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {

    constructor() {
      super();

      this.elForm = this.querySelector('form');
      this.elVariant = this.elForm.querySelector('[name="id"]');
      this.elQuantity = this.elForm.querySelector('[name="quantity"]');
      this.elProperties = this.elForm.querySelectorAll("input[name^='properties']");
      this.elSubmit = this.elForm.querySelector('button[type="submit"]');
      this.elContainer = this.closest('[data-form-container]');
      this.elPrices = this.elContainer ? this.elContainer.querySelectorAll('[data-product-price]') : [];
      this.elSubscriptionPrice = this.querySelector('[data-subscription-price]');
      this.elSellingPlans = this.querySelectorAll('[name="selling_plan"]');
      this.elPurchaseOptions = this.querySelectorAll('[name="subscription"]');
      this.elSubscriptionLabel = this.querySelector('[data-subscription-label]');
      this.elVariants = this.querySelector('[data-variants]');

      this.variants = JSON.parse(this.elVariants.innerHTML);
      this.currentVariant = this.variants.find(v => v.id == this.elVariant.value);
      this.currentOptions = {...this.currentVariant.options};
      this.currentSubscription = this.currentVariant.selling_plans ? this.currentVariant.selling_plans.find(plan => plan.selected) : null;
      this.hasSubscription = !!this.currentSubscription;
      
      this.elForm.addEventListener('change', this.onFormChange.bind(this));
      this.elForm.addEventListener('submit', this.addToCart.bind(this));
    }

    onFormChange({ target }) {
      (target.name == 'subscription' || target.name == 'selling_plan') && this.setCurrentSubscription(target.name, target.value);
      target.name.includes('option') && this.setCurrentVariant(target.name, target.value);
    }

    setCurrentSubscription(name, value) {
      this.hasSubscription = name == 'subscription' ? value !== 'onetime' : this.hasSubscription;
      this.currentSubscription = name == 'selling_plan' ? this.currentVariant.selling_plans.find(plan => plan.id == Number(value)) : this.currentSubscription;
      this.updateSubscriptionUI();
    }

    updateSubscriptionUI() {
      this.elSubscriptionPrice.innerHTML = this.currentSubscription.price;
      this.elSubscriptionLabel.innerHTML = this.currentSubscription.label;
    }

    setCurrentVariant(option, value) {
      this.currentOptions[option] = value;
      this.currentVariant = this.variants.find(variant => JSON.stringify(variant.options) == JSON.stringify(this.currentOptions));
      this.currentSubscription && (this.currentSubscription = this.currentVariant.selling_plans.find(plan => plan.name == this.currentSubscription.name));

      this.elSubmit.disabled = !this.currentVariant.available;
      this.elSubmit.innerHTML = this.currentVariant.available ? this.elSubmit.getAttribute('data-default') : 'Sold Out';
      this.elPrices.forEach(el => el.innerHTML = this.currentVariant.price);
      this.currentSubscription && this.updateSubscriptionUI();

      window.history.replaceState({}, "", this.currentVariant.url);
    }

    addToCart(ev) {
      ev.preventDefault();
      const { id } = this.currentVariant;
      const { value: quantity } = this.elQuantity;

      const properties = this.elProperties ? Object.assign({}, ...[...this.elProperties].map(el => {
        const name = el.name.split('properties[')[1].split(']')[0];
        return { [name]: el.value };
      })) : {};

      const data = { 
        id,
        quantity,
        properties,
        ...(this.hasSubscription ? { selling_plan: this.currentSubscription.id } : '')
      };

      window.addToCart(data);
    }
  }

  customElements.define('product-form', ProductForm);
}